// src/virtual-agent/context.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { openChatWidget, setVacFrameVisibilityHidden } from "@shared-ui/customer-virtual-agent-control";
// ../internal/src/utils/virtual-agent-helper/virtual-agent-control-helpers.ts
var sendMessage = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(data, logEvents) {
        var _window_VirtualAgentControl, _window, _window1, isInit, chatInstance, _chatInstance_vacFrame;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(((_window = window) === null || _window === void 0 ? void 0 : (_window_VirtualAgentControl = _window.VirtualAgentControl) === null || _window_VirtualAgentControl === void 0 ? void 0 : _window_VirtualAgentControl.initialized) && ((_window1 = window) === null || _window1 === void 0 ? void 0 : _window1.VacClientAdapter))) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        window.VirtualAgentControl.initialized
                    ];
                case 1:
                    isInit = _state.sent();
                    if (!isInit) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        window.VacClientAdapter.getInstance()
                    ];
                case 2:
                    chatInstance = _state.sent();
                    return [
                        4,
                        chatInstance.isInitialized
                    ];
                case 3:
                    if (_state.sent()) {
                        ;
                        logEvents === null || logEvents === void 0 ? void 0 : logEvents.SENDING_MESSAGE.log({
                            message: "Sending message - ".concat(data.text)
                        });
                        chatInstance === null || chatInstance === void 0 ? void 0 : (_chatInstance_vacFrame = chatInstance.vacFrame) === null || _chatInstance_vacFrame === void 0 ? void 0 : _chatInstance_vacFrame.sendMessage(data);
                        return [
                            2
                        ];
                    }
                    _state.label = 4;
                case 4:
                    logEvents === null || logEvents === void 0 ? void 0 : logEvents.VAC_NOT_INITIALISED.log({
                        message: "VAC is not initialised when trying to send message - ".concat(data.text)
                    });
                    return [
                        2
                    ];
            }
        });
    });
    return function sendMessage(data, logEvents) {
        return _ref.apply(this, arguments);
    };
}();
// src/virtual-agent/config.ts
var REQUIRED_EVENT = [
    "VAC_ConversationCreated" /* CONVERSATION_CREATED_EVENT */ 
];
// src/virtual-agent/context.tsx
var defaultContextValue = {
    config: {
        eventHandler: function() {
            return console.error("Help Center VA Context Util not yet initialized");
        }
    },
    controller: {
        sendMessage: function() {
            return console.error("Help Center VA Context Util not yet initialized");
        }
    }
};
var VirtualAgentContext = createContext(defaultContextValue);
var VirtualAgentContextProvider = function(param) {
    var children = param.children;
    var _useState = _sliced_to_array(useState(), 2), vaEvent = _useState[0], setVaEvent = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), conversationCreated = _useState1[0], setConversationCreated = _useState1[1];
    var _useState2 = _sliced_to_array(useState(), 2), message = _useState2[0], setMessage = _useState2[1];
    var sendMessage2 = useCallback(function(input) {
        openChatWidget();
        setVacFrameVisibilityHidden(false);
        if (conversationCreated) {
            sendMessage(input);
            setMessage(void 0);
        } else {
            setMessage(input);
        }
    }, [
        conversationCreated,
        setMessage
    ]);
    useEffect(function() {
        if (message) {
            sendMessage(message);
        }
    }, [
        conversationCreated
    ]);
    useEffect(function() {
        if (!vaEvent) {
            return;
        }
        switch(vaEvent.type){
            case "VAC_ConversationCreated" /* CONVERSATION_CREATED_EVENT */ :
                setConversationCreated(true);
                break;
        }
    }, [
        vaEvent
    ]);
    var vaContextValue = useMemo(function() {
        return {
            config: {
                eventHandler: setVaEvent
            },
            controller: {
                sendMessage: sendMessage2
            }
        };
    }, [
        sendMessage2,
        setVaEvent
    ]);
    return /* @__PURE__ */ React.createElement(VirtualAgentContext.Provider, {
        value: vaContextValue
    }, children);
};
var useVirtualAgentContext = function() {
    return useContext(VirtualAgentContext);
};
// src/virtual-agent/mock-context.tsx
import React2, { useMemo as useMemo2 } from "react";
var MockVirtualAgentContextProvider = function(param) {
    var mockController = param.mockController, mockConfig = param.mockConfig, children = param.children;
    var vaContextValue = useMemo2(function() {
        return {
            config: {
                eventHandler: (mockConfig === null || mockConfig === void 0 ? void 0 : mockConfig.eventHandler) || function() {
                    return console.warn("config.eventHandler not set");
                }
            },
            controller: {
                sendMessage: (mockController === null || mockController === void 0 ? void 0 : mockController.sendMessage) || function() {
                    return console.warn("controller.sendMessage not set");
                }
            }
        };
    }, [
        mockController
    ]);
    return /* @__PURE__ */ React2.createElement(VirtualAgentContext.Provider, {
        value: vaContextValue
    }, children);
};
export { MockVirtualAgentContextProvider, REQUIRED_EVENT, VirtualAgentContextProvider, useVirtualAgentContext };
//# sourceMappingURL=index.js.map